export default __webpack_public_path__ + "static/media/log-out.1c83dfa8.svg";